import React from 'react';
import {Box, Typography} from '@mui/material';

const ImageWithCenteredText = ({imageUrl, text}) => {
    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                aspectRatio: '1 / 1',
                maxHeight: {
                    xs: '45vh',
                    sm: '55vh',
                    md: '55vh',
                    lg: '55vh',
                },
                backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(${imageUrl})`,
                // backgroundImage: `url(${imageUrl})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                textAlign: 'center',
            }}
        >
            <Typography
                sx={{
                    fontFamily:'Jost-Regular',
                    color: 'white',
                    fontSize: {
                        xs: '35px',
                        sm: '35px',
                        md: '40px',
                        lg: '50px',
                    },
                    // textShadow: '4px 2px 4px rgba(0, 0, 0, 0.8)',
                    textAlign: 'center',
                    letterSpacing: '0.3rem',
                }}>
                {text.toUpperCase()}
            </Typography>
        </Box>
    );
};

export default ImageWithCenteredText;
